module.exports = __webpack_public_path__ + "img/mode_outline_5.c4d4f78f.png";